<template>
    <p-search-screen
        title="Web Catalog Groups"
        api-destination="catalogs"
        search-destination="searchgroups"
        edit-key="catalogGroupId"
        :edit-url-func="item => `/webcataloggroups/${item.catalogGroupId}`"
        add-url="/webcataloggroups/new"
        :filters="filters"
        :fields="fields"
        :filterBy="filterBy"
        :use-is-active-checkbox="false"
        add-new-button
    >
        <template v-slot:belowSearch>
            <p-form>
                <b-row class="mt-4 me-2">
                        <b-col>
                        <p-checkbox label="Active"
                                    v-model="filters.active" />
                        <p-checkbox label="Inactive"
                                    class="ms-3"
                                    v-model="filters.inactive" />
                        </b-col>
                    </b-row>
            </p-form>
        </template>
    </p-search-screen>
</template>

<script>
import SearchStorage from '@/components/mixins/SearchFilterStorage.js';
import { isActiveFormatter } from '@/components/Common/Formatters.js';
export default {
    mixins: [SearchStorage],
    data() {
        return {
            filterName: 'CatalogGroupsFilter',
            filters: {
                automatic: "",
                perPage: 100,
                sortBy: 'name',
                searchBy: 'Name',
                active: true,
                inactive: false
            },
            filterBy: ['Name'],
            fields: [
                {
                    key: 'name',
                    sortable: true
                },
                {
                    key: 'isActive',
                    label: 'Status',
                    sortable: true,
                    formatter: isActiveFormatter
                }
            ]
        };
    }
};
</script>
<style scoped></style>
